var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlymoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 56,
    viewBox: "0 0 47 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8438 18.3614C32.8438 22.4932 29.4943 25.8428 25.3624 25.8428C21.2306 25.8428 17.881 22.4932 17.881 18.3614C17.881 14.2296 21.2306 10.88 25.3624 10.88C29.4943 10.88 32.8438 14.2296 32.8438 18.3614Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13354 38.986L12.2078 33.9708C12.2078 33.9708 13.1814 33.1152 14.2434 33.1152C15.3055 33.1152 26.1031 33.1742 26.1031 33.1742C27.8732 33.2922 28.4927 34.3248 28.4927 35.1213C28.4927 36.3899 28.0797 37.7765 26.3096 37.7765",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6453 37.7468H32.1509C32.1509 37.7468 33.2424 37.5993 34.1275 36.6848C34.983 35.7702 42.4765 28.3063 42.4765 28.3063C42.4765 28.3063 43.863 26.9788 45.1906 28.3063C46.5182 29.6339 45.8101 30.991 45.8101 30.991L32.9769 44.7977C32.9769 44.7977 32.4164 45.5942 31.2068 45.6237C29.9973 45.6532 21.7663 45.6237 21.7663 45.6237C21.7663 45.6237 20.6158 45.5352 20.2027 45.9777C19.7602 46.4202 17.1641 49.0164 17.1641 49.0164",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7692 10.6942C22.7692 10.6942 22.7987 8.39309 18.7275 6.94752C15.8363 5.91497 12.0601 3.28934 11.8241 1.48975C11.8241 1.48975 10.821 3.02382 11.4406 5.05943C12.0601 7.09503 12.7091 7.68506 13.9187 8.4521",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.588 5.94434C11.588 5.94434 10.6145 8.21595 11.6765 9.92704C12.7091 11.6381 14.1547 12.1986 14.1547 12.1986",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6764 9.92725C11.6764 9.92725 11.2929 12.7299 12.237 14.0575C12.591 14.5885 13.6825 15.444 14.5971 15.7685",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.798 14.6763C12.798 14.6763 12.3554 17.5969 14.6271 19.249C16.2792 20.4586 17.6657 20.4291 17.6657 20.4291",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7671 13.1425C31.7671 13.1425 32.8587 11.1069 37.1069 11.8149C40.1161 12.3164 44.7183 11.8149 45.7804 10.3398C45.7804 10.3398 45.9279 12.1689 44.3938 13.6735C42.8597 15.1781 42.0337 15.3551 40.5881 15.4731",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8333 14.3223C43.8333 14.3223 43.5973 16.7709 41.8567 17.7739C40.1161 18.777 38.582 18.5705 38.582 18.5705",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8566 17.7744C41.8566 17.7744 40.824 20.4 39.3785 21.1376C38.8179 21.4031 37.4314 21.6686 36.4873 21.4916",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6112 21.4033C38.6112 21.4033 37.5786 24.1765 34.8055 24.5305C32.7699 24.796 31.5603 24.1175 31.5603 24.1175",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8923 20.6155L25.514 21.318C26.3119 21.5318 27.1068 21.0729 27.313 20.3035C27.5191 19.5341 27.0602 18.7392 26.2623 18.5254L25.1224 18.22C24.3245 18.0062 23.8656 17.2113 24.0718 16.4419C24.2779 15.6725 25.0728 15.2135 25.8707 15.4273L28.0365 16.0076",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 21.0967L24.3592 22.322",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5049 14.3145L26.1766 15.5398",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_299_2460",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9816,
    height: 7.25173,
    rx: 1.08236,
    transform: "matrix(0.70686 0.707353 -0.707357 0.706857 5.59229 37.7627)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.9816,
    height: 7.25173,
    rx: 1.08236,
    transform: "matrix(0.70686 0.707353 -0.707357 0.706857 5.59229 37.7627)",
    stroke: "#4C4C4C",
    strokeWidth: 3.09246,
    strokeLinejoin: "round",
    mask: "url(#path-15-inside-1_299_2460)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlymoney);
export default __webpack_public_path__ + "static/media/icon_flymoney.6439befd40aa88c5570b1aa01ed425ff.svg";
export { ForwardRef as ReactComponent };